import { render, staticRenderFns } from "./lj.html?vue&type=template&id=67d99669&"
import script from "./lj.js?vue&type=script&lang=js&"
export * from "./lj.js?vue&type=script&lang=js&"
import style0 from "./lj.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports